
export default {
  props: {
    label: String,
    required: Boolean,
    content: String,
  },

  computed: {
    _content: {
      set(value) {
        this.$emit('update:content', value)
        /*
         * TODO POSITION ACTION CLOSE is not good
         */
        this.$store.commit('notification/actionClose')
      },

      get() {
        return this.content
      },
    },
  },

  mounted() {
    if (this.content === undefined) this._content = ''
  },
}
